export const COMPLETION_STATES = {
  ready: 'ready',
  pending: 'pending',
  retryable: 'retryable',
  blocked: 'blocked',
  completed: 'completed',
};

export function evaluateCompletionRecovery(session) {
  const status = session?.status;

  if (status === 'COMPLETED') {
    return {
      state: COMPLETION_STATES.completed,
      errorCode: null,
    };
  }

  if (status === 'COMPLETING') {
    return {
      state: session?.completion_retry_allowed
        ? COMPLETION_STATES.retryable
        : COMPLETION_STATES.pending,
      errorCode: session?.completion_error_code ?? null,
    };
  }

  if (status === 'FAILED_RECOVERABLE') {
    return {
      state: session?.completion_retry_allowed
        ? COMPLETION_STATES.retryable
        : COMPLETION_STATES.blocked,
      errorCode: session?.completion_error_code ?? null,
    };
  }

  return {
    state: COMPLETION_STATES.ready,
    errorCode: null,
  };
}
